import Vue from "vue";
//事件总线
export default new Vue()


// WEBPACK FOOTER //
// ./src/eventBus/eventBus.js